import type { RootState } from 'state';
import type { RoutesFiltersOptionsState } from '../slice';

function getAirportsTo(state: RootState): RoutesFiltersOptionsState['airportsTo'] {
  const { airportsTo } = state.flightRoutes.filtersOptions;
  return airportsTo;
}

export default getAirportsTo;
